module.exports = __webpack_public_path__ + "static/media/01C.e0a855d4.png";